<template>
  <div class="row">
    <RwvProductItem v-for="(product, index) of products" :key="index" :currentIndex="index" :product="product">
        
    </RwvProductItem>
  </div>
</template>
<script>
import RwvProductItem from "./ProductItem";
export default {
  name: "RwvProductListItem",
  components: {
    RwvProductItem
  },
  props: {
    products: Array
  },methods: {
    doMath: function() {
      return index+1;
    }
  }
};
</script>
<style>
  .item-prd .img-prd img{
    object-fit: cover;
    height: 170px;
    object-position: 50% 0;
}
</style>